import React from 'react'

const WeekView = ({ week, selectedWeekly, onSelectedWeekly, setSelectedWeekly }) => {

  const renderDay = (item, index, _selectedWeekly) => {
    const isSelected = Boolean(_selectedWeekly && _selectedWeekly.includes(item.key))
    const layoutStyle = isSelected ? 'option-highlighted-circle' : 'option-circle'
    const textStyle = isSelected ? 'option-highlighted-circle-text' : 'option-circle-text'

    return (
      <div
        key={index}
        style={{ marginLeft: index !== 0 ? 12 : 0 }}
        className={layoutStyle}
        onClick={() => onSelectedWeekly(item.key, _selectedWeekly)}
      >
        <label className={textStyle}>{item.value}</label>
      </div>
    )
  }

  return (
    <div className='week-layout'>
      {week.map((item, index) => renderDay(item, index, selectedWeekly))}
    </div>
  )
}

export default WeekView
